<template>
  <BreadCrumb PageTitle="Nouveau Virement" />
  <NewVirement />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import NewVirement from "@/components/Virements/NewVirement.vue";

export default defineComponent({
  name: "NewVirementPage",
  components: {
    BreadCrumb,
    NewVirement,
  },
});
</script>